module.exports = __webpack_public_path__ + "img/长腿瘦身--自定义调节.9acf23dd.png";